import React, { useState } from 'react'
import { Button, Card, Modal } from 'react-bootstrap'

const VideoPlayerModal = ({link, title, handleClose, show}) => {


    return (
        <>

            <Modal
                size="xl"
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                <Card.Body className='youtubePlayer-main'>
                <iframe
                    className="sketchfab-inside-videoPlayer p-2 p-md-3"
                    src={`https://www.youtube.com/embed/${link}&autoplay=1`}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                ></iframe>
            </Card.Body>
            </Modal>
      

        </>
    )
}

export default VideoPlayerModal